export function padTo2Digits(num) {
	return num.toString().padStart(2, '0');
}

export const convertToMinutes = (seconds) => Math.ceil(seconds / 60);

export const formatToTimeInput = (date, separator = ':') => {
	const hours = padTo2Digits(date.getHours());
	const minutes = padTo2Digits(date.getMinutes());
	return `${hours}${separator}${minutes}`;
};

export const formatDateToCurrentDay = (date, separator = '/') =>
	`${padTo2Digits(date.getDate())}${separator}${padTo2Digits(
		date.getMonth() + 1,
	)}`;

export const formatToTimeLabel = (date) => {
	const hours = padTo2Digits(date.getHours());
	const minutes = padTo2Digits(date.getMinutes());
	return `${hours}h${minutes}`;
};

export function formatDate(date, separator = '-') {
	return `${date.getFullYear()}${separator}${padTo2Digits(
		date.getMonth() + 1,
	)}${separator}${padTo2Digits(date.getDate())}`;
}

export const formatDateFR = (date) =>
	`${`0${date.getDate()}`.slice(-2)}/${`0${date.getMonth() + 1}`.slice(
		-2,
	)}/${date.getFullYear()}`;

export const formatDatetime = (date) =>
	`${`0${date.getDate()}`.slice(-2)}/${`0${date.getMonth() + 1}`.slice(
		-2,
	)}/${date.getFullYear()} ${`0${date.getHours()}`.slice(
		-2,
	)}h${`0${date.getMinutes()}`.slice(-2)}`;

export function formatDateLabel(date, separator = '-') {
	return `${padTo2Digits(date.getDate())}${separator}${padTo2Digits(
		date.getMonth() + 1,
	)}${separator}${date.getFullYear()}`;
}

export function getDayName(date) {
	return date.toLocaleDateString('fr', { weekday: 'long' });
}

export function getMonthName(date) {
	return date.toLocaleDateString('fr', { month: 'long' });
}

export const formatToHumanDate = (date) =>
	`${getDayName(date)} ${padTo2Digits(date.getDate())} ${getMonthName(
		date,
	)} `;

export const isValidDate = (dateObject) =>
	new Date(dateObject).toString() !== 'Invalid Date';

export const formatStringToDate = (dateString) => {
	// input format 01-08-2020 08:00 output format 2020-08-01T08:00:00.000Z
	// split string
	const dateArray = dateString.split(' ');
	const date = dateArray[0].split('-');
	const time = dateArray[1].split(':');
	const year = date[2];
	const month = date[1];
	const day = date[0];

	const hour = time[0];
	const minute = time[1];

	const newDate = new Date(year, month - 1, day, hour, minute);
	return newDate;
};

export const getFormattedTime = (date) => {
	const timeComponents = [
		date.getHours(),
		date.getMinutes(),
		date.getSeconds(),
	];
	const month = date.getMonth();
	const day = date.getDate();
	const year = date.getFullYear();
	const timezone = Math.abs(date.getTimezoneOffset() / 60);

	const time = timeComponents
		.map((component) => {
			const pad = component < 10 ? '0' : '';
			return pad + component;
		})
		.join(':');
	let padDay = day < 10 ? '0' : '';
	padDay += day;
	let padMonth = month + 1 < 10 ? '0' : '';
	padMonth += month + 1;
	return `${year}-${padMonth}-${padDay}T${time}+0${timezone}:00`;
};

export const getFormattedUTCDate = (date) => {
	const month = date.getMonth();
	const day = date.getDate();
	const year = date.getFullYear();
	let padDay = day < 10 ? '0' : '';
	padDay += day;
	let padMonth = month + 1 < 10 ? '0' : '';
	padMonth += month + 1;
	return `${year}-${padMonth}-${padDay}T22:00:00.000Z`;
};

export const timeValide = (date) => {
	if (date === '' || date === null || date === undefined) {
		return false;
	}
	const hour = date.getHours();
	if (hour > 6 && hour < 20) {
		return true;
	}
	return false;
};

export const formatWeek = (mydate) => {
	const startDate = new Date(mydate.getFullYear(), 0, 1);
	const days = Math.floor((mydate - startDate) / (24 * 60 * 60 * 1000)) + 1;

	const startDay = startDate.getDay();

	const daysAdjusted = days + (startDay === 0 ? 1 : startDay - 1);
	const week = Math.ceil(daysAdjusted / 7);
	return `${week}/${mydate.getFullYear()}`;
};

export const isSunday = (date) => {
	if (date.getDay() === 0) {
		return true;
	}
	return false;
};

export const getStringTime = (date) => {
	const tabDate = date.split('T');
	const tabTime = tabDate[1].split(':');

	return `${tabTime[0]}:${tabTime[1]}`;
};

export const getStringDate = (date) => {
	const tabDate = date.split('T');
	const tabDate1 = tabDate[0].split('-');

	return `${tabDate1[2]}-${tabDate1[1]}-${tabDate1[0]}`;
};

export const getBrutStringDate = (date) => {
	const tabDate = date.split('T');

	return `${tabDate[0]}`;
};
